import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../../core/_BLComponent.jsx';
import Slider from 'react-slick';

export default class BDPQuickViewModal extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
			activeIndex: this.props.submissions.findIndex(submission => submission.idSubmission == this.props.activeSubmission),
			bgColor: '#FFFFFF',
		}

		this.slickSettings = {
			dots: true,
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			afterChange: (index) => this.getBgColor(this.props.submissions[this.state.activeIndex].arrImages[index].dmImage.url)
		}
	}

	componentDidMount() {
		this.getBgColor(this.props.submissions[this.state.activeIndex].arrImages[0].dmImage.url);
		this.refreshVoteResult(this.props.submissions[this.state.activeIndex].idSubmission);
		this.preloadNeighbors();
	}

	componentDidUpdate(prevProps, prevState) {
		if(prevState.activeIndex != this.state.activeIndex) {
			this.getBgColor(this.props.submissions[this.state.activeIndex].arrImages[0].dmImage.url);
			this.refreshVoteResult(this.props.submissions[this.state.activeIndex].idSubmission);
			this.setState({showDescription: false});
			this.submissionSlider.slickGoTo(0, true);
			this.preloadNeighbors();
		}
	}

	render() {
		const {closeFunc, submissions, activeSubmission} = this.props;
		const submission = submissions[this.state.activeIndex];

		const galleryImages = submission.arrImages.map((image, idx) => <div className="bdp-quick-view__image"><img loading={idx == 0 ? 'eager' : ''} key={idx} src={image.dmImage.url} alt={submission.dmBDPSeries.strName + ' - ' + image.dmImage.strFileName}/></div>);
		const designer 			= {idUser: submission.dmUserBuilder.dmUser.idUser, image: blapp.url2.getProfileImgUrl(submission.dmUserBuilder.dmUser, 'medium'), name: submission.dmUserBuilder.dmUser.skUsername};
		const bgColor 			= this.state.bgColor;
		const textClass 		= this.getContrastYIQ(bgColor);

		return (
			<div className="modal">
				<div className="modal__overlay" onClick={() => closeFunc()}/>
				<div className="modal__content bdp-quick-view__modal-content">
					<article className={`bdp-quick-view bdp-quick-view--${textClass}`}>
						<div className={`bdp-quick-view__main bdp-quick-view__main--${textClass}`} style={{backgroundColor: bgColor}}>
							<header className="bdp-quick-view__header">
								<h1 className="bdp-quick-view__title"><a href={blapp.url2.getBDPSubmissionDesignViewUrl(submission.idSubmission)} target="_blank">{submission.strSubmissionName}<i className="far fa-square-arrow-up-right l-margin-left text--small-title"/></a></h1>
								<div className="l-flex l-center">
									<div data-ts-name="bdp-model__designer" className="bdp-model__designer l-margin-right">
										<a className="bdp-model__designer-image" target="_blank" href={blapp.url2.getStudioPublicGalleryUrl(designer.idUser)}>
											<img src={designer.image}/>
										</a>
										<a className="bdp-model__designer-name text--inherit" target="_blank" href={blapp.url2.getStudioPublicGalleryUrl(designer.idUser)}>{designer.name}</a>
									</div>
									<div className="bdp-model__series-tag l-nowrap">{submission.dmBDPSeries.strName}</div>
								</div>
							</header>
							<Slider className="bdp-quick-view__images slick-slider--adaptive" ref={submissionSlider => this.submissionSlider = submissionSlider} {...this.slickSettings}>
								{galleryImages}
							</Slider>
						</div>
						<div className="bdp-quick-view__details">
							{this.renderNav()}
							{this.renderVoting()}
							<div className="bdp-quick-view__details-content">
								<div className="bdp-quick-view__details-internal">
									{this.renderPartsInfo()}
									{this.renderDescription()}
									<div className="l-border--top l-pad-y--xl l-margin-top--xl">
										<a className="btn btn--cta btn--wide text--bold l-inline-block" href={blapp.url2.getBDPSubmissionDesignViewUrl(submission.idSubmission)}>View full details<i className="fas fa-long-arrow-right l-margin-left"/></a>
									</div>
								</div>
							</div>
						</div>
					</article>
				</div>
			</div>
		);
	}

	renderNav() {
		const {submissions, closeFunc} = this.props;

		return(
			<div className="bdp-quick-view__nav">
				<div className="bdp-quick-view__pagination">
					<button className="btn btn--beveled bdp-quick-view__pagination-item" disabled={this.state.activeIndex == 0} onClick={() => this.paginate(this.state.activeIndex - 1)}><i className="fas fa-caret-left"/></button>
					<button className="btn btn--beveled bdp-quick-view__pagination-item" disabled={this.state.activeIndex == submissions.length} onClick={() => this.paginate(this.state.activeIndex + 1)}><i className="fas fa-caret-right"/></button>
				</div>
				<button className="btn btn--blank l-pad bdp-quick-view__close" onClick={() => closeFunc()}><i className="fas fa-xmark-large"/></button>
			</div>
		);
	}

	renderVoting() {
		const {submissions}			= this.props;
  	const isPostValidation	= blapp.config.server_time > submissions[this.state.activeIndex].dmBDPSeries.udtCrowdValidationEnd;

		return (
			<section className="bdp-quick-view__vote">
				<h2 className="text--small-title text--bold l-margin-bottom--sm">Add your vote</h2>
				<div data-ts-name="bdp-model__voting" className={"vote-card__container bdp-quick-view__vote-group" + (isPostValidation ? ' bdp-series-detail__vote-group--disabled' : '')}>
					<article data-ts-name="bdp-quick-view__vote-item bdp-model__vote-item--no" className={"bdp-quick-view__vote-item  vote-card" + (this.state.vote == 1 ? ' vote-card--active' : '')} onClick={() => this.vote(1)}>
						<button className="vote-card__internal">
							<img className="vote-card__image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-1.png`}/>
							<div className="vote-card__text">Not for me</div>
						</button>
					</article>
					<article data-ts-name="bdp-quick-view__vote-item bdp-model__vote-item--like" className={"bdp-quick-view__vote-item  vote-card" + (this.state.vote == 2 ? ' vote-card--active' : '')} onClick={() => this.vote(2)}>
						<button className="vote-card__internal">
							<img className="vote-card__image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-2.png`}/>
							<div className="vote-card__text">Like it!</div>
						</button>
					</article>
					<article data-ts-name="bdp-quick-view__vote-item bdp-model__vote-item--yes" className={"bdp-quick-view__vote-item  vote-card" + (this.state.vote == 3 ? ' vote-card--active' : '')} onClick={() => this.vote(3)}>
						<button className="vote-card__internal">
							<img className="vote-card__image" src={`//${blapp.config.getHost( "static2" )}/img/bdp/vote-3.png`}/>
							<div className="vote-card__text">Love it!</div>
						</button>
					</article>
				</div>
			</section>
		);
	}

	renderPartsInfo() {
		const {submissions} = this.props;
		const submission 		= submissions[this.state.activeIndex];

		return (
			<section className="bdp-quick-view__parts-info">
				<h2 className="text--small-title text--bold l-margin-bottom--sm">Parts info</h2>
				{submission.nTotalLots ? <div className="text--small-title l-inline-flex l-center l-margin-right--xl"><i className="text-color--darkest48 far fa-fw fa-cube l-margin-right--sm"/>{submission.nTotalLotsOverride > 0 ? submission.nTotalLotsOverride : submission.nTotalLots} unique parts</div> : null}
				{submission.nTotalParts ? <div className="text--small-title l-inline-flex l-center l-margin-right--xl"><i className="text-color--darkest48 far fa-fw fa-cubes l-margin-right--sm"/>{submission.nTotalPartsOverride > 0 ? submission.nTotalPartsOverride : submission.nTotalParts} total parts</div> : null}
				{submission.nStickerCnt ? <div className="text--small-title l-inline-flex l-center"><i className="text-color--darkest48 far fa-fw fa-note-sticky l-margin-right--sm"/>{submission.nStickerCntOverride > 0 ? submission.nStickerCntOverride : submission.nStickerCnt} stickers</div> : null}
			</section>
		);
	}

	renderDescription() {
		const {submissions} = this.props;
		const submission 		= submissions[this.state.activeIndex];

		return (
			<section>
				<button className="btn btn--link" onClick={() => this.setState({showDescription: !this.state.showDescription})}>{this.state.showDescription ? 'Hide' : 'Show'} description<i className={`fas fa-caret-${this.state.showDescription ? 'up' : 'down'} l-margin-left--sm`}/></button>
				{this.state.showDescription && <div className="l-margin-top" dangerouslySetInnerHTML={{__html: submission.strSubmissionDescription}}/>}
			</section>
		);
	}

	vote(vote) {
  	const isPostValidation = blapp.config.server_time > this.props.submissions[this.state.activeIndex].dmBDPSeries.udtCrowdValidationEnd;
		
		if(isPostValidation) {
			return false;
		}else{
			if ( blapp.session.isLoggedIn() ) {
				this.doVote(vote);
			} else {
				blapp.refs.get( "header" ).showLogin(
					() => {
						if ( blapp.session.isLoggedIn() ) {
							this.refreshVoteResult();
						}
					}
				);			
			}
		}
	}

	doVote(vote){
		const me = blapp.session.getMe();

		if(me.statusBuyer == 1) {
			this.triggerAlert( "Please confirm your email first!" );
			return;
		}else if(me.statusBuyer != 0 || me.statusSeller == 2) {
			this.triggerAlert( "You need an account in good standing to vote.");
			return;
		}

		blapp.models.fetch(
			"_vote_response"
		,	{
				controller:	"bdp.BLCBDPSubmission"
			,	method:		"voteBDPSubmission"
			,	params:		[ this.props.submissions[this.state.activeIndex].idSubmission, vote ]
			,	refresh:	true
			}
		).then(
			( data ) =>	{
				this.refreshVoteResult(this.props.submissions[this.state.activeIndex].idSubmission);
			}
		);
	}

	refreshVoteResult(idSubmission) {
		blapp.models.fetch(
			"_vote_result"
		,	{
				controller:	"bdp.BLCBDPSubmission"
			,	method:		"getVoteBDPSubmission"
			,	params:		[ idSubmission ]
			,	refresh:	true
			}
		).then(
			( data ) =>	{
				this.setState({vote: data});
			}
		);
	}

	getBgColor = (imageUrl) => {
		const canvas = document.createElement("canvas");
		const context = canvas.getContext('2d');
		let myImg = new Image();

		myImg.crossOrigin = "Anonymous";
		myImg.src = imageUrl;
		myImg.onload = () => {
			context.drawImage(myImg, 0, 0);
			const c = context.getImageData(0, 0, 1, 1).data;
			const hex = "#" + ("000000" + this.rgbToHex(c[0], c[1], c[2])).slice(-6);
			this.setState({bgColor: hex});
		}
	}

	rgbToHex = (r, g, b) => {
		if (r > 255 || g > 255 || b > 255)
			throw "Invalid color component";
		return ((r << 16) | (g << 8) | b).toString(16);
	}

	getContrastYIQ(hexcolor) {
		if(hexcolor.slice(0, 1) === '#') {
			hexcolor = hexcolor.slice(1);
		}

		const r = parseInt(hexcolor.substr(0, 2), 16);
		const g = parseInt(hexcolor.substr(2, 2), 16);
		const b = parseInt(hexcolor.substr(4, 2), 16);
		const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

		return (yiq >= 128) ? 'dark' : 'light';
	}

	paginate(index) {
		this.setState({activeIndex: index});
	}

	preloadNeighbors() {
		const nextImages = this.state.activeIndex == this.props.submissions.length ? [] : this.props.submissions[this.state.activeIndex + 1].arrImages;
		const prevImages = this.state.activeIndex == 0 ? [] : this.props.submissions[this.state.activeIndex - 1].arrImages;

		const images = [...nextImages, ...prevImages];
		console.log(images);

		images.map(image => {
			let img = new Image();
  		img.src = image.dmImage.url;
		});
	}
}